

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://c098db2425c540d3982e073ae7fc4c9a@sentry.wixpress.com/3531", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/c2e2b59e62116bb/comments-web/comments-widget/src/components/CommentsWidget/Widget/index.tsx';
    import createController from '/home/builduser/work/c2e2b59e62116bb/comments-web/comments-widget/src/components/CommentsWidget/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'CommentsWidget';
    var projectName = 'comments-widget';
    var sentryConfig = {
      DSN: 'https://c098db2425c540d3982e073ae7fc4c9a@sentry.wixpress.com/3531',
      id: 'c098db2425c540d3982e073ae7fc4c9a',
      projectName: 'comments-widget',
      teamName: 'forum',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/c2e2b59e62116bb/comments-web/comments-widget/src/components/CommentsWidget/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"scopes":["wix-comments"],"centralized":true};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/c2e2b59e62116bb/comments-web/comments-widget/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"markLabel.bestAnswer.label":"Best Answer","markLabel.bestAnswer.markAction":"Mark as Best Answer","markLabel.bestAnswer.unmarkAction":"Unmark as Best Answer","markLabel.solved.label":"Solved","markLabel.solved.markAction":"Mark as Solved","markLabel.solved.unmarkAction":"Unmark as Solved","markLabel.featured.label":"Featured","markLabel.featured.markAction":"Mark as Featured","markLabel.featured.unmarkAction":"Unmark as Featured","markLabel.pinned.label":"Pinned","markLabel.pinned.markAction":"Mark as Pinned","markLabel.pinned.unmarkAction":"Unmark as Pinned","markLabel.custom.markAction":"Mark as {customLabel}","markLabel.custom.unmarkAction":"Unmark as {customLabel}","demoContent.comment01":"Your site visitors can leave comments like this one to create a conversation around your site’s content. Some can be just plain text and some can contain images, gifs, videos and other embedded content.","demoContent.comment02":"Comments can be as short or as long as your visitors would like.","demoContent.reply01":"Other visitors can also reply to comments.","demoContent.reply02":"There are even replies to a reply.","demoContent.replierName":"Replier Name","demoContent.commenterName":"Commenter Name","demoContent.alert":"These are demo comments. They will not be shown live when you publish your site.","settings.textTab.headerTitleTextDefault":"Comments","settings.textTab.headerTitleText":"{count, plural, =0 {{title}} other {{title} ({count})}}","settings.textTab.placeholderTextDefault":"Write a comment","settings.textTab.publishButtonTextDefault":"Publish","settings.textTab.likeButtonTextDefault":"Like","settings.textTab.replyButtonTextDefault":"Reply","settings.settingsTab.ratingSelectorTextDefault":"Add a rating","settings.textTab.adminBadgeTextDefault":"Admin"};
    var styleHocConfig = {"enabled":true};
    var biConfig = {"enableUniversalEvents":true};
    var appDefinitionId = "91c9d6a7-6667-41fb-b0b4-7d3b3ff0b02e";
    var componentId = "1c154801-444a-49ad-aee8-325ff74f89b1";
    var localeDistPath = 'components/CommentsWidget/locales/widget';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/c2e2b59e62116bb/comments-web/comments-widget/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
